import { Button, DialogTitle, Divider, useId, makeStyles, Radio, RadioGroup } from "@fluentui/react-components";
import React, { useState } from "react";
import { useUsersContext } from "../../../contexts/UserContext";
import { useUtilitiesContext } from "../../../contexts/UtilitiesContext";
import BaseUserCombobox from "../../../components/BaseUserCombobox";
import OverlaySpinner from "../../../components/OverlaySpinner";
import { useUserAssignmentExportDialogStore } from "../store/UserAssignmentExportDialogStore";
import ApiClient from "../../../api/ApiClient";

const useStyles = makeStyles({
    assignRow: {
        display: 'flex',
        flexDirection: 'row',
        gap: '10px',
        marginTop: '10px',
        alignItems: 'center',
    },
    assignLabel: {
        whiteSpace: 'nowrap',
        flexShrink: 0,
        fontWeight: 'bold',
    },
    tableWrapper: {
        maxHeight: '250px',
        overflowY: 'auto',
    },
    deviceTable: {
        minWidth: '510px',
    },
    actionButtons: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '10px',
        gap: '10px',
    },
    noDataCell: {
        textAlign: "center",
        padding: "32px 0",
        fontSize: "1.2rem",
        fontWeight: "500",
        color: "#888"
    }
});

export default function ExportInfo() {
    const comboboxId = useId("combobox");
    const styles = useStyles();

    const { users } = useUsersContext();
    const { isExporting, close, setLoading } = useUserAssignmentExportDialogStore();

    const { showNotification } = useUtilitiesContext();
    const [userId, setUserId] = useState<string>("");
    const [type, setType] = React.useState("onboarding");
    

    const onError = (error: Error) => {
        showNotification({
            type: "error",
            title: "Error",
            message: error.message,
        });
    };

    const onSubmit = async () => {
        try {
            setLoading(true);
            const response = await ApiClient({ url: `/user-assignments/export`,
                method: "GET",
                params: {uid: userId, type}, 
                responseType:  "blob"
            });
    
            if (response.status === 200) {
                const disposition = response.headers['content-disposition'];
                let filename = "download.pdf";
    
                if (disposition) {
                    const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (match && match[1]) {
                        filename = match[1].replace(/['"]/g, "");
                    }
                }
    
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            }
            close();
        } catch (error) {
            onError(error as Error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <OverlaySpinner open={isExporting} label={"Exporting...."} />

            <DialogTitle>Export Assignment</DialogTitle>
            <div className={styles.assignRow}>
                <div className={styles.assignLabel}>User:</div>
                <BaseUserCombobox
                    id={comboboxId}
                    data={users}
                    defaultValue={""}
                    disabled={false}
                    onChange={setUserId}
                />
            </div>
            <div className={styles.assignRow}>
                    <div className={styles.assignLabel}>Export Type:</div>
                    <RadioGroup style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }} onChange={(_, data) => setType(data.value)}>
                        <Radio value="onboarding" label="On-boarding" defaultChecked/>
                        <Radio value="offboarding" label="Off-boarding" />
                    </RadioGroup>
            </div>
            <Divider appearance="strong" />
            <div className={styles.actionButtons}>
                <Button onClick={close} appearance="secondary">Close</Button>
                <Button onClick={onSubmit} appearance="primary" disabled={!userId}>Export</Button>
            </div>
        </>
    )
}